import "../style/Tunesien.css";
import { Container } from "react-bootstrap";
import tunesienHero from "./images/Sidi-Bou-Said.avif";
import tunesienGeo from "./images/Geographie.jpg";
import tunesienHistory from "./images/Geschichte.jpg";
import tunesienFreizeit from "./images/Freizeitaktivitaeten.jpg";
import tunesienKultur from "./images/Kultur.jpg";
import tunesienBildung from "./images/Doctor.png";
import tunesienFamilie from "./images/Familie_und_Religion.jpg";

function Tunesien() {
  const cardItems = [
    {
      title: "Geographie",
      description: "Erkunden Sie die atemberaubende Landschaft Tunesiens.",
      image: tunesienGeo,
      href: "#geographie",
    },
    {
      title: "Geschichte",
      description: "Ein kleiner Einblick in die Geschichte Tunesiens.",
      image: tunesienHistory,
      href: "#geschichte",
    },
    {
      title: "Freizeitaktivitäten",
      description: "Genießen Sie vielfältige Freizeitaktivitäten.",
      image: tunesienFreizeit,
      href: "#freizeit",
    },
    {
      title: "Kultur",
      description: "Tauchen Sie ein in die reiche Kultur.",
      image: tunesienKultur,
      href: "#kultur",
    },
    {
      title: "Bildungssystem",
      description: "Erfahren Sie mehr über das Bildungs- und Gesundheitssystem.",
      image: tunesienBildung,
      href: "#bildung",
    },
    {
      title: "Familie und Religion",
      description: "Entdecken Sie die Bedeutung von Familie und Religion.",
      image: tunesienFamilie,
      href: "#familie",
    },
  ];

  const geographieHighlights = [
    {
      title: "Die Küstenlandschaft Tunesiens erleben",
      description:
        "Die Lage Tunesiens an der Mittelmeerküste Nordafrikas schenkt dem Land eine beeindruckende landschaftliche Vielfalt. Kilometerlange Sandstrände, ruhige Buchten und das kristallklare, türkisfarbene Mittelmeer prägen die Küste und machen Tunesien zu einem Ort von besonderer natürlicher Schönheit.",
    },
    {
      title: "Die Faszination der Sahara entdecken",
      description:
        "Abseits der Küste eröffnet sich mit der Sahara eine völlig andere, ebenso beeindruckende Welt. Endlose Dünenlandschaften, weite Horizonte und eine einzigartige Stille prägen diese majestätische Wüste. Erlebnisse wie Kameltouren oder Nächte unter dem funkelnden Sternenhimmel machen die Sahara zu einem unvergesslichen Naturerlebnis.",
    },
    {
      title: "Die natürliche Vielfalt Tunesiens",
      description:
        "Tunesien begeistert durch seine außergewöhnliche landschaftliche Vielfalt. Fruchtbare Ebenen, grüne Oasen, beeindruckende Gebirgszüge und spektakuläre Schluchten vereinen sich zu einem facettenreichen Naturbild. Diese Vielfalt bietet ideale Bedingungen für Outdoor-Aktivitäten und einzigartige Erlebnisse inmitten einer faszinierenden Naturkulisse.",
    },
  ];

  const geschichteHighlights = [
    {
      title: "Die Geschichte Tunesiens erleben",
      description:
        "Tunesien blickt auf eine jahrtausendealte Geschichte zurück und beherbergt zahlreiche historische Stätten und beeindruckende Ruinen vergangener Hochkulturen. Von phönizischen Siedlungen bis zu römischen Städten erzählt das Land die faszinierende Geschichte bedeutender Zivilisationen, die den Mittelmeerraum nachhaltig geprägt haben.",
    },
    {
      title: "Karthago – Das Erbe einer phönizischen Metropole",
      description:
        "Die antike Stadt Karthago zählt zu den bedeutendsten historischen Orten Tunesiens. Einst eine mächtige Handelsmetropole der Phönizier, hinterließ Karthago ein reiches kulturelles und politisches Erbe. Die archäologischen Überreste bieten heute einen eindrucksvollen Einblick in die Geschichte einer Stadt, die über Jahrhunderte hinweg eine zentrale Rolle in der Region spielte.",
    },
    {
      title: "Dougga – Römische Pracht inmitten der Natur",
      description:
        "Dougga gilt als eine der besterhaltenen römischen Ausgrabungsstätten Nordafrikas. Monumentale Bauwerke, Tempel und Theater zeugen von der einstigen Bedeutung der Stadt im Römischen Reich. Eingebettet in eine beeindruckende Landschaft vermittelt Dougga eindrucksvoll die Größe und den Einfluss der römischen Kultur in Tunesien.",
    },
  ];

  const freizeitHighlights = [
    {
      title: "Entspannung an traumhaften Küstenstränden",
      description:
        "Die Strände Tunesiens stehen für Erholung und Entspannung für Besucher aller Altersgruppen. Feiner Sand, klares Wasser und eine idyllische Kulisse laden zum Sonnenbaden, Schwimmen sowie zu vielfältigen Wassersportaktivitäten ein.",
    },
    {
      title: "Abenteuer in faszinierenden Wüstenlandschaften",
      description:
        "Die weitläufigen Wüsten Tunesiens versprechen einzigartige Abenteuer. Kameltouren durch die Sahara eröffnen unvergessliche Eindrücke, darunter spektakuläre Sonnenaufgänge und der beeindruckende Sternenhimmel der Wüste.",
    },
    {
      title: "Erlebnis der lebendigen Souks und traditionellen Handwerkskunst",
      description:
        "Die tunesischen Souks begeistern mit traditioneller Handwerkskunst, Farben und exotischen Gewürzen. Besucher erleben hier das lebhafte Markttreiben und entdecken handgefertigte Unikate mit kulturellem Charakter.",
    },
  ];

  const kulturHighlights = [
    {
      title: "Die kulturelle Vielfalt Tunesiens",
      description:
        "Tunesien ist ein Land, das von arabischen, berberischen und mediterranen Einflüssen geprägt wird und eine beeindruckende kulturelle Vielfalt bietet. Von traditioneller Musik und Tanz bis hin zu landestypischen Speisen wie Couscous und Tajine ist Tunesien ein wahres Erlebnis für alle Sinne.",
    },
    {
      title: "Musik, Tanz und kulturelle Ausdrucksformen",
      description:
        "Die tunesische Kultur zeichnet sich durch eine reiche musikalische und tänzerische Tradition aus. Instrumente wie die Oud und die Darbuka schaffen mit ihren Klängen eine besondere Atmosphäre. Besucher haben die Möglichkeit, die Vielfalt dieser kulturellen Ausdrucksformen hautnah zu erleben.",
    },
    {
      title: "Kulinarische Köstlichkeiten und herzliche Gastfreundschaft",
      description:
        "Auch die tunesische Küche ist äußerst vielfältig und traditionsreich. Von herzhaften Couscous-Variationen bis zu würzigen Tajines bietet sie intensive Geschmackserlebnisse. Die herzliche Gastfreundschaft der Menschen macht es leicht, die Kultur authentisch kennenzulernen.",
    },
  ];

  const bildungHighlights = [
    {
      title: "Das Bildungssystem in Tunesien – Vielfalt und Qualität",
      description:
        "Tunesien misst Bildung einen hohen Stellenwert bei und fördert ein leistungsorientiertes und vielfältiges Bildungssystem. Von der schulischen Grundausbildung bis hin zu Hochschulen und Universitäten bietet das Land zahlreiche Bildungswege und solide akademische Perspektiven.",
    },
    {
      title: "Das tunesische Gesundheitssystem – Entwicklung und Kompetenz",
      description:
        "In den vergangenen Jahren hat sich das tunesische Gesundheitssystem kontinuierlich weiterentwickelt. Moderne medizinische Einrichtungen sowie gut ausgebildete Fachkräfte sorgen für eine qualitativ hochwertige und umfassende Gesundheitsversorgung.",
    },
    {
      title: "Medizinische Ausbildung und Gesundheitswesen",
      description:
        "Die medizinische Ausbildung in Tunesien entspricht hohen Standards und bildet qualifizierte Fachkräfte für den Gesundheitssektor aus. Präventive Maßnahmen, medizinische Forschung und spezialisierte Behandlungsformen stehen dabei im Mittelpunkt.",
    },
  ];

  const familieReligionHighlights = [
    {
      title: "Die zentrale Rolle der Familie in Tunesien",
      description:
        "In der tunesischen Gesellschaft nimmt die Familie einen besonders hohen Stellenwert ein. Gemeinsame Zeit, gegenseitige Unterstützung und ein starkes Zusammengehörigkeitsgefühl prägen das soziale Miteinander.",
    },
    {
      title: "Religion als Bestandteil des täglichen Lebens",
      description:
        "Der Islam spielt für viele Tunesier eine wichtige Rolle im Alltag. Gebete, Moscheebesuche und religiöse Feiertage bieten Orientierung, Halt und strukturieren das gesellschaftliche Leben.",
    },
    {
      title: "Familie und Religion als verbindende Elemente",
      description:
        "Die gemeinsame Ausübung religiöser Traditionen stärkt familiäre Beziehungen und prägt den Alltag. Weitergegebene Werte und Überzeugungen fördern Gemeinschaftssinn, Solidarität und Zusammenhalt.",
    },
  ];

  return (
    <>
      <div className="tunesien-hero">
        <img src={tunesienHero} alt="Tunesien Landschaft" />
        <div className="tunesien-hero-overlay">
          <div className="tunesien-hero-title">
            Das Land unserer
            <br />
            Bewerber
          </div>
          <div className="tunesien-hero-subtitle">Willkommen in der faszinierenden Welt Tunesiens!</div>
          <a className="tunesien-hero-btn" href="#tunesien-details">
            Mehr über Tunesien
          </a>
        </div>
      </div>

      <Container id="tunesien-details" className="tunesien-section">
        <div className="tunesien-main-card">
          <div className="tunesien-heading">
            <h5>Medway stellt vor</h5>
            <h2>Tunesien</h2>
            <div className="tunesien-divider" />
            <p>
              Willkommen auf unserer Seite rund um Tunesien. Hier möchten wir Ihnen dieses vielfältige und kulturell reiche
              Land näher vorstellen. Da viele unserer qualifizierten Bewerber aus Tunesien stammen, ist es uns ein besonderes
              Anliegen, Ihnen einen Einblick in ihre Herkunft zu geben und Ihnen Tunesien als Land und Kultur näherzubringen.
            </p>
          </div>

          <div className="tunesien-grid">
            {cardItems.map((item) => (
              <div className="tunesien-card" key={item.title}>
                <img src={item.image} alt={item.title} />
                <div className="tunesien-card-body">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <a className="tunesien-card-link" href={item.href}>
                    {item.title === "Bildungssystem"
                      ? "Zum Bildungssystem"
                      : item.title === "Familie und Religion"
                      ? "Zur Familie und Religion"
                      : item.title === "Freizeitaktivitäten"
                      ? "Zu Freizeitaktivitäten"
                      : `Zur ${item.title}`}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>

      <section className="tunesien-feature-wrap" id="geographie">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-image">
            <img src={tunesienGeo} alt="Geographie Tunesien" />
            <div className="tunesien-feature-overlay">
              <h3>Geographie</h3>
              <p>Erkunden Sie die atemberaubende Landschaft</p>
            </div>
          </div>
          <div className="tunesien-feature-list">
            {geographieHighlights.map((item) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tunesien-feature-wrap" id="geschichte">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-list">
            {geschichteHighlights.map((item, idx) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="tunesien-feature-image">
            <img src={tunesienHistory} alt="Geschichte Tunesiens" />
            <div className="tunesien-feature-overlay">
              <h3>Geschichte</h3>
              <p>Ein kleiner Einblick in die Geschichte Tunesiens</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tunesien-feature-wrap" id="freizeit">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-image">
            <img src={tunesienFreizeit} alt="Freizeitaktivitäten in Tunesien" />
            <div className="tunesien-feature-overlay">
              <h3>Freizeitaktivitäten</h3>
              <p>Erkunden Sie die atemberaubende Landschaft</p>
            </div>
          </div>
          <div className="tunesien-feature-list">
            {freizeitHighlights.map((item, idx) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tunesien-feature-wrap" id="kultur">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-list">
            {kulturHighlights.map((item, idx) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="tunesien-feature-image">
            <img src={tunesienKultur} alt="Kultur in Tunesien" />
            <div className="tunesien-feature-overlay">
              <h3>Kultur</h3>
              <p>Tauchen Sie ein in die reiche Kultur</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tunesien-feature-wrap" id="bildung">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-image">
            <img src={tunesienBildung} alt="Bildungssystem in Tunesien" />
            <div className="tunesien-feature-overlay">
              <h3>Bildungssystem</h3>
              <p>Erfahren Sie mehr über das Bildungs- und Gesundheitssystem</p>
            </div>
          </div>
          <div className="tunesien-feature-list">
            {bildungHighlights.map((item, idx) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tunesien-feature-wrap" id="familie">
        <div className="tunesien-feature-section">
          <div className="tunesien-feature-list">
            {familieReligionHighlights.map((item, idx) => (
              <div className="tunesien-feature-item" key={item.title}>
                <div className="tunesien-feature-icon" aria-hidden="true">→</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="tunesien-feature-image">
            <img src={tunesienFamilie} alt="Familie und Religion in Tunesien" />
            <div className="tunesien-feature-overlay">
              <h3>Familie und Religion</h3>
              <p>Entdecken Sie die Bedeutung von Familie und Religion</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Tunesien;
